import { IconButton, Tooltip } from "@mui/material";
import { icons } from "../../../../../../../../utils/icons";
import { useEditFolioStyles } from "./editFolioStyles";
import { BaseMenu } from "../../../../../../../../components";
import { MouseEventHandler, useState } from "react";
import { hiddenSetting, useMenuList, validateLifeCicleStatus } from "./contants";
import { useReportFoliosDetailContext } from "../../hooks/useReportFoliosContext";
import { Roles, Status } from "../../../../../../../../utils/enums";
import { getLocalStorage, LocaleNameType } from "../../../../../../../../utils/crud/crypt";
import { useTranslation } from "react-i18next";
import { reportFolioDetailMenuType } from "../../enums";
import { Priority } from "../../../../../../../../utils/enums/priority";
import { DataDetail } from "../../types";
import { AnswerTypeHistory } from "../../enums/answerType";
import { FolioTypeEndPoint } from "../../../../utils/enums/endpointFolioType";

const EditFolio = ({ lifeCicle, reportUrl, data, hasApprovedOrRejected, existSolutionCaseMgDpto }: {
    lifeCicle?: number;
    reportUrl?: string | null;
    data: DataDetail;
    hasApprovedOrRejected: boolean;
    existSolutionCaseMgDpto: boolean;
}) => { //statusAttentionId
    const state: { isManagerOfDeparment: boolean, role: number, id: string | number } = getLocalStorage(LocaleNameType.STATE);

    const { t } = useTranslation();
    const userId = state?.id;
    const roleId = state?.role;
    const { selectOption, creatorUser, statusAttencion, userAssigned } = useReportFoliosDetailContext();
    let menuList = useMenuList();
    const styles = useEditFolioStyles();
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const position = {top: `-50px`, left: `-115px`} 
    const openMenu: MouseEventHandler<HTMLButtonElement> = (e) => {
        setAnchorEl(e.currentTarget);
    };

    //if (lifeCicle && ((!validateLifeCicleStatus.includes(lifeCicle) && !reportUrl) || hiddenSetting.includes(lifeCicle))) return null;

    const statusAttencionId = statusAttencion.statusAttentionId;
    const canResend = [Status.REJECTED, Status.APPROVED].includes(lifeCicle as Status);
    const isUserAssigned = statusAttencion?.userAttendingId === userId;
    const isCreaterUser = creatorUser?.id === userId;
    const isManagerOfDepartment = state?.isManagerOfDeparment;
    const isAdmin = roleId === Roles.ADMIN;
    const canReassignProvider = !!data.left?.canReassign
    const isSomeAssignedUser = userAssigned.some(item => item.id === userId);
    const isUserWithPermissions = (!isAdmin && !isCreaterUser && !isUserAssigned && !isManagerOfDepartment);

    const isPriorityHigh = data?.left?.priority?.id === Priority.HIGH || data?.left?.priority?.id === Priority.URGENT;
    const isStatusBlocked = [19, 13, 5].includes(data?.left?.status?.id);

    // Check if there's a pending solution from provider
    const hasPendingSolution = data?.historial?.items[0]?.type === AnswerTypeHistory.SOLUTION || data?.historial?.items[0]?.type === AnswerTypeHistory.MANAGE_SOLUTION;

    // Remove edit option before evaluating conditions
    menuList = menuList.filter(item => item.value !== reportFolioDetailMenuType.EDIT);

    // Validations for area and department reassignment
    const canReassignAreaDepartment =
        !isPriorityHigh &&
        !hasApprovedOrRejected &&
        !existSolutionCaseMgDpto &&
        ![Status.APPROVED, Status.REJECTED, Status.CANCEL, Status.EXPIRED, Status.NOT_FINISHED].includes(lifeCicle) &&
        (!!data.right && !data.right.existAnyQuote) && data.left.statusAttentionId !== Status.STARTED &&
        (isAdmin || isManagerOfDepartment || isCreaterUser);

    if (!canReassignAreaDepartment) {
        menuList = menuList.filter(item => item.value !== reportFolioDetailMenuType.REASSIGN_AREA_DEPARTMENT);
    }

    const canReassignUser =
        (
            (isAdmin || isUserAssigned || isManagerOfDepartment || canReassignProvider) &&
            ![Status.APPROVED, Status.REJECTED, Status.CANCEL, Status.EXPIRED, Status.NOT_FINISHED].includes(lifeCicle) && //2
            !hasApprovedOrRejected &&
            !existSolutionCaseMgDpto &&
            //!isPriorityHigh &&
            data?.left?.type != FolioTypeEndPoint.PREVENTIVE
            //!hasPendingSolution
        ) || ( data?.left?.userAssignedAmount == 0 && canReassignProvider)

    if (!canReassignUser) {
        menuList = menuList.filter(item => item.value !== reportFolioDetailMenuType.REASIGN_USER);
    }
  
    const canShowEditOption = !isPriorityHigh /* && !hasApprovedOrRejected */ &&
        (isAdmin || isCreaterUser || isManagerOfDepartment) &&
        ![Status.EXPIRED, Status.NOT_FINISHED].includes(lifeCicle) &&
        !isStatusBlocked && (!!data.right && !data.right.existAnyQuote) && data.left.statusAttentionId !== Status.STARTED;

    const canCancelFolio = (isAdmin || isManagerOfDepartment || isCreaterUser) &&
        ![Status.EXPIRED, Status.NOT_FINISHED].includes(lifeCicle) &&
        ![Status.CANCEL].includes(lifeCicle as Status) && (!!data.right && !data.right.existAnyQuote) && data.left.statusAttentionId !== Status.STARTED;

    if (!canCancelFolio) {
        menuList = menuList.filter(item => item.value !== reportFolioDetailMenuType.CANCEL);
    }

    /* if (!canReassignUser && !isCreaterUser) {
        menuList = menuList.filter(item => item.value !== reportFolioDetailMenuType.REASIGN_USER);
    } */

    /* if (!canResend) {
        menuList = menuList.filter(item => item.value !== reportFolioDetailMenuType.RESEND_REPORT);
    } */

    if (lifeCicle === Status.CANCEL) {
        menuList = menuList.filter(item =>
            [reportFolioDetailMenuType.RESEND_REPORT, reportFolioDetailMenuType.SEE_REPORT].includes(item.value)
        );
    }

    if ((lifeCicle === Status.APPROVED || lifeCicle === Status.REJECTED) && isUserWithPermissions) {
        menuList = menuList.filter(item => item.value !== reportFolioDetailMenuType.REASSING_PROVIDER);
    }

    // Handle menu items for users with limited permissions
    if (isUserWithPermissions || !menuList.length) {
        menuList = [];

        if (canReassignUser) {
            menuList.push({
                label: t('general.reassignUser'),
                value: reportFolioDetailMenuType.REASIGN_USER
            });
        }
        if (canResend) {
            menuList.push({
                label: t('general.resendReport'),
                value: reportFolioDetailMenuType.RESEND_REPORT
            });
        }
        if (canCancelFolio) {
            menuList.push({
                label: t('general.cancel'),
                value: reportFolioDetailMenuType.CANCEL
            });
        }
    }

    if (canShowEditOption) {
        menuList.unshift({
            label: t('general.edit'),
            value: reportFolioDetailMenuType.EDIT
        });
    }

    if (!menuList.length) return null;

    return (
        <>
            <Tooltip title={t('ToolTips.seeActions')}>
                <IconButton onClick={openMenu} sx={styles.more}>{icons('moreHoriz')}</IconButton>
            </Tooltip>

            <BaseMenu
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                menuItems={menuList}
                click={selectOption}
                sx={position}
            />
        </>
    );
};

export { EditFolio };